import React, { useEffect, useState, Suspense } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import ErrorBoundray from "../components/ErrorBoundray/ErrorBoundray";
import dataServices from "../common/dataServices";

const ContactUs = React.lazy(() => import("../components/ContactUs/ContactUs"));
const Footer = React.lazy(() => import("../components/Footer/Footer"));
const ModSlider = React.lazy(() => import("../components/Slider/Slider"));
const SingelItem = React.lazy(() => import("../components/SingelItem/SingelItem"));
const AllPersons = React.lazy(() => import("../components/Grid/GridAllPersons/AllPersons"));
const DiscussionsGrid = React.lazy(() => import("../components/Grid/DiscussionsGrid/DiscussionsGrid"));
const NewPublicationsGrid = React.lazy(() => import("../components/Grid/NewPublicationsGrid/NewPublicationsGrid"));
const HomePage = React.lazy(() => import("../components/HomePage/HomePage"));
const SearchResult = React.lazy(() => import("../components/SearchResult/SearchResult"));
const MiniResult = React.lazy(() => import("../components/SearchResult/MiniResult"));
const TimeLine = React.lazy(() => import("../components/timeLine/TimeLine"));
const VideoPlayer = React.lazy(() => import("../components/Video/VideoPlayer"));
const Hybrid = React.lazy(() => import("../components/Hybrid/Hybrid"));
const DocList = React.lazy(() => import("../components/DocList/DocList"));
const HantzachaPage = React.lazy(() => import("../components/Hantzacha/HantzachaPage"));
import "./index.css";

const ModWebParts = (props) => {
  const [items, setItems] = useState(null);
  let type = props.webPartProperties.type;
  let webpartTitle = props.webPartProperties.title;
  let webpartLink = props.webPartProperties.readMoreLink;
  let webpartLinkTitle = props.webPartProperties.readMoreTitle;
  let webpartLayout = props.webPartProperties.layout;
  let freeText = props.webPartProperties.ModText;
  let WpId = props.webPartProperties.WpId;
  let siteUrl = props.webPartProperties.site;
  let loadSPList = props.webPartProperties.LoadSPList === "True";

  useEffect(() => {
    //for loadingProgressUI
   // $("#ctl00_AccessibilityMenu2").hide();
    // componentDidMount - GetListItems
    let listName = props.webPartProperties.listName;
    let viewName = props.webPartProperties.listView;
    //debugger;
    if (loadSPList) {
      dataServices
        .getSPListItems(siteUrl, listName, viewName)
        .then((response) => response.data)
        .then((lsItemsResponse) => {
          try {
            setItems(lsItemsResponse.Data);
          } catch (e) {
            console.log(e);
          }
        });
    }
    else {
      setItems({});
    }  
  }, []);


  const loadingProgressUI = () => {
    return (<div className="loading-progress"></div>)
  }


  if (items === null) {
    return null;
  }

  let selectedWP = "";
  switch (type) {
    case "Footer":
      selectedWP = <Footer items={items} />;
      break;
    case "Tabs":
      selectedWP = <Hybrid
        typeWP="Tabs"
        webpartID={WpId}
        listData={items}
        webpartTitle={webpartTitle}
      />
      break;
    case "Slider":
      selectedWP = (
        <ModSlider
          items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle}
          siteUrl={siteUrl}
          viewName={props.webPartProperties.listView}
          listName={props.webPartProperties.listName}
        />
      );
      break;
    case "ContactUs":
      selectedWP = (
        <ContactUs
          items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle}
        />
      );
      break;
    case "Article":
      selectedWP = <SingelItem items={items} />;
      break;
    case "News":
      selectedWP = <HantzachaPage
        items={items}
        freeText={freeText}
        mainURL={siteUrl}
        siteName={webpartLinkTitle}
        title={webpartTitle} />;
      break;
    case "Documents":
      selectedWP = (
        <DocList items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle} />
      );
      break;
    case "Grid":
      // selectedWP = (
      //   <AllPersons
      //     items={items}
      //     mainURL={siteUrl}
      //     siteName={webpartLinkTitle}
      //     title={webpartTitle}
      //     type={freeText}
      //   />

      // );
      // break;
      if (webpartLayout == "first") {
        selectedWP = (
          <AllPersons
            items={items}
            mainURL={siteUrl}
            siteName={webpartLinkTitle}
            title={webpartTitle}
            type={freeText}
          />);
      } else if (webpartLayout == "second") {
        selectedWP = <DiscussionsGrid
          items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle}
          type={freeText}
        />;
      }
      else if (webpartLayout == "third") {
        selectedWP = <NewPublicationsGrid
          items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle}
          type={freeText}
        />;
      }
      break;

    case "SearchResult":
      if (webpartLayout == "first") {
        selectedWP = (
          <React.Fragment>

            <SearchResult
              mainURL={siteUrl}
              siteName={webpartLinkTitle}
              title={webpartTitle}
              type={freeText}
            />
          </React.Fragment>
        );

      } else if (webpartLayout == "second") {
        selectedWP = (
          <React.Fragment>

            <MiniResult
              mainURL={siteUrl}
              siteName={webpartLinkTitle}
              title={webpartTitle}
              type={freeText}
            />
          </React.Fragment>
        );
      }
      break;
    // 
    case "Lobby":
      selectedWP = (
        <HomePage
          items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle}
        />
      );

      break;
    //     let listName = props.webPartProperties.listName;
    //let viewName = props.webPartProperties.listView;
    case "Flowchart":
      selectedWP = (
        <TimeLine
          items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle}
          viewName={props.webPartProperties.listView}
          listName={props.webPartProperties.listName}
        />

      );
      break;
    case "Video":
      selectedWP = (
        <VideoPlayer
          items={items}
          mainURL={siteUrl}
          siteName={webpartLinkTitle}
          title={webpartTitle}
          viewName={props.webPartProperties.listView}
          listName={props.webPartProperties.listName}
          id={WpId}
          freeText={freeText}
        />
      );
      break;
    case "Auditoriums":
      selectedWP = (
        <DiscussionsGrid
          webpartTitle={webpartTitle}
        />
      );
      break;
    case "Links":

      selectedWP = (
        <Hybrid
          typeWP="Links"
          webpartID={WpId}
          listData={items}
          webpartTitle={webpartTitle}
        />
      );
      break;

    case "Collections":

      if (webpartLayout == "first") {
        selectedWP = <Hybrid
          typeWP="CollectionsEventsInPerson"
          webpartID={WpId}
          listData={items}
          webpartTitle={webpartTitle}
        />;
      } else if (webpartLayout == "second") {
        selectedWP = <Hybrid
          typeWP="CollectionsPersonsInEvents"
          webpartID={WpId}
          listData={items}
          webpartTitle={webpartTitle}
        />;
      }
      break;

    default:
      break;
  }

  return (
    <div className={"modWPContainer " + type + "_" + webpartLayout}>
      <ErrorBoundray>
        <Suspense fallback={loadingProgressUI()}>    
            {selectedWP}
        </Suspense>
      </ErrorBoundray>
    </div>
  );
};
export default ModWebParts;
